module.exports = {
  CssSelectorParser: require('./lib/css-selector-parser.js').CssSelectorParser
};